
<footer id="webSiteFooterId">
  <div class="content-footer_foundation text-center d-flex justify-content-center">
    <div class="col-lg-9 col-md-10 text-center d-flex flex-column-reverse flex-md-row align-items-center justify-content-between my-4 my-lg-0 my-md-2 gap-3 gap-lg-0">
      <div>
        <p class="col-12 py-3 mb-0 text-white signature-crezco">
          © {{ crezcoYear }} Crezco Foundation Inc.
        </p>
      </div>
      <div class="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">
        <div class="mx-3">
          <a class="extra-link-footer text-decoration-none text-white" [routerLink]="['/']">
            Privacy Policy
            <i class="fa-solid fa-arrow-right"></i>
          </a>
        </div>
        <div class="mx-3">
          <a class="extra-link-footer text-decoration-none text-white" [routerLink]="['/']">
            Terms of Use
            <i class="fa-solid fa-arrow-right"></i>
          </a>
        </div>
        <div class="ms-lg-3">
          <a class="extra-link-footer text-decoration-none text-white" [routerLink]="['/auth/login']">
            Login Admin
            <i class="fa-regular fa-user ms-1"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</footer>

